import React, { useState } from "react";
import styles from "../../../styles/components/video.module.scss";
import { Box, Button, Tooltip, styled, tooltipClasses } from "@mui/material";
import assest from "../../../json/assest";
import { getUtcDateTime, linkFinder } from "../../../lib/functions/utils.lib";
import { useMutation } from "react-query";
import { createLink } from "../../../api/functions/links.api";
import ApiLoader from "../../Loaders/ApiLoader";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 199,
    height: 94,
    fontSize: theme.typography.pxToRem(12),
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25);",
    borderRadius: "10px 10px 0px 10px;",
    border: "none",
    padding: "10px 12px",
    margin: "0px",
  },
}));

const AddOriginalVideoLinks = ({ data, refetchVideo }) => {
  // console.warn("data", data);

  const [addVideoLink, setAddVideoLink] = useState(false);
  const [addNewLink, setAddNewLink] = useState(false);

  // console.warn("addVideoLink", addVideoLink);
  // console.warn("addNewLink", addNewLink);

  const { mutate, isLoading } = useMutation(createLink, {
    onSuccess: (data) => {
      console.warn("upadate", data);
      // const message = "success";
      // alert(message);
      // window.location.reload();
      setAddVideoLink(false);
      setAddNewLink(false);
      refetchVideo();
      setUrl("");
      //   refetchNote();
    },
    onError: (error) => {
      console.warn("error", error);
    },
  });

  const foundLinks = linkFinder(data.links, "original_file_url");
  // console.warn("foundLinks", foundLinks);

  const [url, setUrl] = useState("");

  const handleAddLink = () => {
    mutate({
      video_id: data.id,
      key: "original_file_url",
      url: url,
    });
  };

  const cancleAddLink = () => {
    setAddNewLink(false);
    setAddVideoLink(false);
    setUrl("");
  };

  return (
    <div>
      <ApiLoader loading={isLoading} />
      <Box className={styles.videoLink}>
        {foundLinks.length < 1 && !addVideoLink && (
          <Button onClick={() => setAddVideoLink(true)}>
            <img src={assest.videoFileIcon} height={18} width={18} alt="" /> Add
            original video file (VS Link)
          </Button>
        )}

        {(addVideoLink || foundLinks.length > 0) && (
          <>
            <h5>Original Video File(s)</h5>
            <Box className={styles.videoLinkBoxWrapper}>
              {foundLinks.map((link, i, links) => (
                <Box className={styles.videoLinkBox}>
                  <Box className={styles.inputBox}>
                    <p>{i + 1}.</p>
                    <input
                      type="text"
                      disabled
                      // placeholder="https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                      value={link.url}
                    />
                  </Box>
                  <Box className={styles.linkIcon}>
                    <Box className={styles.toolTipBox}>
                      <HtmlTooltip
                        placement="top-end"
                        className="toolTip"
                        // open={true}
                        title={
                          <React.Fragment>
                            <Box className={styles.toolTipTxt}>
                              <h5>Added by:</h5>
                              <p>{link.submited_by?.role?.name}</p>
                            </Box>
                            <Box className={styles.toolTipTxt}>
                              <h5>Date:</h5>
                              <p>{getUtcDateTime(link.created_at)}</p>
                            </Box>
                          </React.Fragment>
                        }
                      >
                        <Button>
                          <img
                            src={assest.toolTipIcon}
                            width={11}
                            height={11}
                            alt=""
                          />
                        </Button>
                      </HtmlTooltip>
                    </Box>
                    {links.length == i + 1 && !addNewLink && (
                      <Box
                        className={`${styles.videoLinkBox} ${styles.plusIconBlack}`}
                      >
                        <Button onClick={() => setAddNewLink(true)}>
                          <img
                            src={assest.plusIconBlack}
                            width={22}
                            height={23}
                            alt=""
                          />
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              ))}

              {(addNewLink || addVideoLink) && (
                <Box className={styles.videoLinkBox}>
                  <Box className={styles.inputBox}>
                    <p>{foundLinks.length + 1}.</p>
                    <input
                      type="text"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                    />
                  </Box>

                  <Box className={styles.linkIcon}>
                    {/* <Button>
                      <img
                        src={assest.plusIconBlack}
                        width={22}
                        height={23}
                        alt=""
                      />
                    </Button> */}
                    <Box className={styles.crossAddicon}>
                      <Button onClick={handleAddLink}>
                        <img
                          src={assest.rightIconBlack}
                          width={22}
                          height={23}
                          alt=""
                        />
                      </Button>
                      <Button onClick={cancleAddLink}>
                        <img
                          src={assest.crossIconBlack}
                          width={22}
                          height={23}
                          alt=""
                        />
                      </Button>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
    </div>
  );
};

export default AddOriginalVideoLinks;
